import React, { Component } from 'react';
import StepHeader from '../../common/StepHeader';
import { connect } from 'react-redux';
import KidsSafetyValidation from '../utils/KidsSafetyValidation';
import withRouter from 'components/components/common/withRouter';
import BookingRedirect from '../utils/BookingRedirect';
import SafetyList from './components/SafetyList';
import { setKidsSafetyNumber } from 'components/actions/bookingActions';
import TransHelper from 'components/common/translations/TransHelper';

class KidsSafety extends Component {

  componentDidMount() {
    new BookingRedirect(this.props).canViewKidsSafety();
  }

  goNext = (event) => {
    event.preventDefault();
    TransHelper.redirect(this.props, 'routes.url.flights');
  }

  backRedirect = () => {
    var home = TransHelper.translateRoute(this.props.locale, 'routes.url.home');
    return this.props.startFromBooking ? 'routes.url.booking' : home;
  }

  isValidForm = () => {
    return new KidsSafetyValidation(this.props).isValidForm();
  }

  trans = (key, prefix = 'content.kidsSafety') => {
    return TransHelper.translate(this.props.locale, prefix + "." + key);
  }

  render() {
    var transPrefCommon = 'content.common';

    return (
      <div className="content" style={{ padding: 0 }}>
        <div className="grid-layout grid-layout--vh">
          <div className="grid-layout__item grid-layout__item--desc grid-layout__item--middle">
            <div className="content__desc content__desc--static">
              <StepHeader
                link={this.backRedirect()}
                linkTitle={this.trans('backToBooking', transPrefCommon)}
                step={1}
                booking
                title={this.trans('title')}
                isAnim={true}
              />

              <div className="text-center" style={{ marginTop: '-15px' }}>
                <p className="no-marg" style={{ marginBottom: '-2px!important' }}>
                  {TransHelper.translate('content.common.next')}
                  {this.trans('tripWithCount')}
                  {this.props.childrenNumber}
                  {this.trans('tripWithCountSufix')}
                </p>
                <p style={{ marginBottom: '7px' }}> {this.trans('typeOfSeatsQuestion')}</p>
              </div>

              <form>
                <fieldset>
                  <legend className="visuallyhidden">{this.trans('title')}</legend>
                  <SafetyList
                    childrenNumber={this.props.childrenNumber}
                    kidsSafety={this.props.kidsSafety}
                    setKidsSafetyNumber={this.props.setKidsSafetyNumber}
                    locale={this.props.locale}
                  />
                  <button
                    className="button button--outline button--expand"
                    onClick={this.goNext}
                    disabled={!this.isValidForm()}
                  >
                    {this.trans('next', transPrefCommon)}
                  </button>
                </fieldset>
              </form>
            </div>
          </div>

          <div className="grid-layout__item grid-layout__item--info" />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    locale: state.app.locale,
    kidsSafety: state.booking.kidsSafety,
    childrenNumber: state.booking.childrenNumber,
    startFromBooking: state.booking.startFromBooking
  };
};

export default withRouter(connect(mapStateToProps, { setKidsSafetyNumber })(KidsSafety));
